module.exports = (theme) => ({
  ".ab-background-container": { "@apply ds-max-w-[1920px] ds-m-auto": 1 },
  ".alert-banner[type='warning'] .ab-background-container": { "@apply ds-bg-background-yellow": 1 },
  ".alert-banner[type='information'] .ab-background-container": { "@apply ds-bg-background-blue": 1 },
  ".alert-banner[type='user'] .ab-background-container": { "@apply ds-bg-background-green": 1 },

  ".ab-is-notified": { "@apply ds-hidden": 1 },
  ".ab-is-notified:checked + .ab-collapse-container": { "@apply ds-max-h-0": 1 },
  ".ab-collapse-container": { "@apply ds-overflow-hidden ds-max-h-[750px] ds-transition-[max-height] ds-duration-300": 1 },

  ".ab-module-container": { "@apply ds-flex ds-gap-xl ds-py-xl ds-px-lg ds-m-auto ds-max-w-4xl": 1 },
  ".ab-close-container label": { "@apply ds-cursor-pointer ds-p-2xs ds-pb-xs": 1 },
  ".ab-module-container > .ab-close-container": { "@apply ds-hidden": 1 },

  ".ab-content-container": { "@apply ds-flex ds-flex-col ds-gap ds-w-full": 1 },
  ".ab-module-container > .ab-alert-icon-container": { "@apply ds-hidden": 1 },
  ".ab-heading-container": { "@apply ds-flex ds-justify-between ds-items-center ds-gap": 1 },

  ".ab-icon": { "@apply !ds-scale-100 !ds-h-[47px] !ds-w-[47px]": 1 },
  ".alert-banner[type='warning'] .ab-icon": { "@apply ds-icons-alert-cmyk": 1 },
  ".alert-banner[type='information'] .ab-icon": { "@apply ds-icons-information": 1 },
  ".alert-banner[type='user'] .ab-icon": { "@apply ds-icons-user": 1 },

  ".ab-heading-container .ab-heading": { "@apply !ds-text-lg !ds-leading-sm ds-max-w-[790px] ds-mr-auto": 1 },
  ".ab-heading-container .ab-close-container": { "@apply ds-hidden": 1 },
  ".ab-text-content-container": { "@apply ds-text-base ds-leading-base ds-font-regular ds-max-w-[790px]": 1 },
  ".ab-cta-container": { "@apply ds-flex ds-justify-between ds-items-center ds-gap-xl": 1 },
  ".ab-cta-container .ab-close-container .ds-icons-close": { "@apply ds-scale-100 !ds-w-[25px] !ds-h-[25px]": 1 },

  [`@media screen and (min-width: ${theme("screens.sm")})`]: {
    ".ab-module-container > .ab-alert-icon-container,\n.ab-module-container > .ab-close-container": { "@apply ds-block": 1 },
    ".ab-heading-container > .ab-alert-icon-container,\n.ab-cta-container > .ab-close-container": { "@apply ds-hidden": 1 },
    ".ab-icon": { "@apply !ds-h-[70px] !ds-w-[70px]": 1 },
    ".ab-close-container": { "@apply ds-pt-[7px]": 1 },
    ".ab-heading-container .ab-heading": { "@apply !ds-text-4xl !ds-leading-xl ds-font-bold": 1 },
  },

  [`@media screen and (min-width: ${theme("screens.md")})`]: {
    ".ab-collapse-container": { "@apply ds-max-h-[500px]": 1 },
    ".ab-module-container": { "@apply ds-py-xl ds-pr-xl ds-pl-3xl": 1 },
    ".ab-module-container > .ab-alert-icon-container": { "@apply ds-pr": 1 },
  },

  [`@media screen and (min-width: ${theme("screens.lg")})`]: {
    ".ab-module-container\n.ab-close-container\n.ds-icons-close": { "@apply ds-scale-100 !ds-w-[32px] !ds-h-[32px]": 1 },
    ".ab-close-container": { "@apply ds-pt-[5px]": 1 },
  },
});
